var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('img',{staticClass:"logo",attrs:{"src":"/logo.png"}}),_c('router-view'),_c('vue-qr',{staticClass:"qr-code",attrs:{"dotScale":0.5,"margin":0,"size":150,"text":encodeURI(_vm.baseUrl + '#' + _vm.$route.path)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }